export default __webpack_public_path__ + "static/media/threemonths.6ce38f66.png";